import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = (theme) =>
    makeStyles(() => ({
        root: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            borderRadius: theme.avatar.common.borderRadius,

            fontSize: theme.avatar.common.fontSize,
            fontWeight: theme.avatar.common.fontWeight,
            textTransform: "uppercase",

            padding: theme.tokens.spacings.s8,

            color: theme.avatar.common.color,
            backgroundColor: theme.avatar.common.backgroundColor,
        },
        defaultSize: {
            width: "40px",
            height: "40px",
        },
    }))();
